define("shared/components/shared/publish/switcher/item/business-button/index", ["exports", "@ember/component", "@ember/component/template-only", "@ember/template-factory"], function (_exports, _component, _templateOnly, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class="o--dropBody">
    {{#if @title}}
      <h4 class="u--text--bold u--text--sm u--m__t__0 u--m__b__xs">{{@title}}</h4>
    {{/if}}
    <p class="u--text--sm u--m__0">
      {{@infoText}}
    </p>
  </div>
  <div class="o--dropFooter u--p__lr u--p__b__xs">
    <Shared::Ui::Button
      @additional="block"
      @onClick={{@onClick}}
      @size="small"
      @text={{@buttonText}}
      @variant="primary"
      data-test-id="business-button"
    />
  </div>
  */
  {
    "id": "UZ1xZRiO",
    "block": "[[[10,0],[14,0,\"o--dropBody\"],[12],[1,\"\\n\"],[41,[30,1],[[[1,\"    \"],[10,\"h4\"],[14,0,\"u--text--bold u--text--sm u--m__t__0 u--m__b__xs\"],[12],[1,[30,1]],[13],[1,\"\\n\"]],[]],null],[1,\"  \"],[10,2],[14,0,\"u--text--sm u--m__0\"],[12],[1,\"\\n    \"],[1,[30,2]],[1,\"\\n  \"],[13],[1,\"\\n\"],[13],[1,\"\\n\"],[10,0],[14,0,\"o--dropFooter u--p__lr u--p__b__xs\"],[12],[1,\"\\n  \"],[8,[39,1],[[24,\"data-test-id\",\"business-button\"]],[[\"@additional\",\"@onClick\",\"@size\",\"@text\",\"@variant\"],[\"block\",[30,3],\"small\",[30,4],\"primary\"]],null],[1,\"\\n\"],[13]],[\"@title\",\"@infoText\",\"@onClick\",\"@buttonText\"],false,[\"if\",\"shared/ui/button\"]]",
    "moduleName": "shared/components/shared/publish/switcher/item/business-button/index.hbs",
    "isStrictMode": false
  });
  var _default = _exports.default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());
});